{
  "name": "12-(3,7) < 256°",
  "description": "12-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes 3 and 7.",
  "scale": [
    "9/8",
    "147/128",
    "81/64",
    "21/16",
    "189/128",
    "3/2",
    "49/32",
    "27/16",
    "7/4",
    "243/128",
    "63/32",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "OddPartials(3,7)",
  "built_in_group": "Odd Partial Pitch Class Sets",
  "key_labels": "note_names",
  "note_names": ["1", "9", "147", "81", "21", "189", "3", "49", "27", "7", "243", "63"],
  "note_colors": [
    "#ff9b9b",
    "#ffffff",
    "#f8c9c9",
    "#ffffff",
    "#ffe5e5",
    "#ffe5e5",
    "#ffffff",
    "#f8c9c9",
    "#ffffff",
    "#ffe5e5",
    "#ffffff",
    "#ffe5e5"
  ],
  "equivSteps": 12,
  "fundamental": 440,
  "reference_degree": 8,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
